import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreLinkComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-link/mapfre-link.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '@models/user';
import { AuthenticationService } from '../../../_services/_iam/authentication-service.service';
import { Router, ActivatedRoute , RouterModule } from '@angular/router';
import { ErrorRedirectionService } from '../../../_services/error-service/error-redirection.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Capacitor } from '@capacitor/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLinkComponent, MapfreButtonComponent],
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss'],
})
export class EmailConfirmationComponent implements OnInit {
  @Input() sendEmailAgain: string;
  user: User = {};
  isAcmic = false;
  showMessageApp = false;
  @Output() showConfirmation: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private authService: AuthenticationService,
    public router: Router,
    public activeRoute: ActivatedRoute,
    private errorRedirectionService: ErrorRedirectionService,
    private acmicService: AcmicService
  ) {}

  forgotPasswordSendEmailId(): void {
    this.user.email = this.sendEmailAgain;

    if (this.user.email) {
      this.authService.forgotPasswordSendEmailId(this.user.email).subscribe(
        () => {
          this.showConfirmation.emit(true);
        },
        (error) => {
          if (error.status) {
            this.errorRedirectionService.redirect(error.status);
          }
        }
      );
    }
  }

  goBackToForm() {
    if (
      this.activeRoute.snapshot.routeConfig.path ==
      'profilepassword/:emailPrefill'
    ) {
      this.router.navigate(['/profilepassword', this.sendEmailAgain]);
    } else {
      this.router.navigate(['/forgotpassword', this.sendEmailAgain]);
    }
    this.showConfirmation.emit(false);
  }

  ngOnInit() {
    if (this.acmicService.isACMIC()) {
      this.isAcmic = true;
    }
    if (Capacitor.isNativePlatform()) {
      this.showMessageApp = true;
    }
  }
}
